// Components
import createEditorTypeToggledTool from './createEditorTypeToggledComponent';
import TextStyleRichTextToolContainer from '../richContentTools/textStylesTool/TextStyleRichTextToolContainer';
import TiptapTextStyleTool from './TiptapTextStyleTool';

// Styles
import './TextStyleTool.scss';

export default createEditorTypeToggledTool(TiptapTextStyleTool, TextStyleRichTextToolContainer);
